module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Q6kfX3/tc-custom/9781426831881.jpg?1738298778006",
      "alt": "This image is the cover for the book Code of Honor"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Code of Honor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Her mission: to nurse the poor and serve God. His mission: to get her out of South America alive . . . A thrilling novel by the Carol Award finalist!")]), _c('br'), _c('br'), _vm._v("Get in, save the girl, and get back out. That was CHAIM agent Brice Whelan’s mission. But saving missionary/nurse Selena Carter might be more difficult than expected. Selena’s run-in with a drug cartel put the people in her care in danger. Yet the danger doesn’t end when Brice brings her home."), _c('br'), _c('br'), _vm._v("The counterfeit drugs have entered Georgia, and this time Selena isn’t about to run away. Brice’s mission hasn’t changed; he still needs to keep her safe. And that means staying by her side—whether she wants him there or not . . ."), _c('br'), _c('br'), _c('b', [_vm._v("Praise for "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author Lenora Worth")]), _c('br'), _c('br'), _vm._v("“The characters [are] warm and engaging . . . the faith element is always present, but is not heavy-handed or intrusive.” —"), _c('i', [_vm._v("Publishers Weekly")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lenora Worth\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0